import { Action, any, async, fromJSX, loadingAsyncState, nothing } from "widgets-for-react";
import { fetchSearchResults } from "./searchPageApi";
import { SearchPageLayout } from "./searchPageLayout";
import { SearchPageState, SearchResult, emptySearchResult } from "./searchPageState";

export const SearchPageWidget = (props: SearchPageState) => {
  return any<Action<SearchPageState>>()([
    fromJSX((setState) => {
      return SearchPageLayout({
        ...props,
        updateQuery: (searchQuery: string) => setState((prevState) => ({ ...prevState, searchQuery })),
        updatePage: (currentPage: number) => setState((prevState) => ({
          ...prevState,
          currentPage,
          searchResults: loadingAsyncState(
            fetchSearchResults(prevState.searchQuery, currentPage, prevState.pageSize),
            previousResult(prevState)
          )
        })),
        runQuery: () => setState((prevState) => newLoadingQuery(prevState.searchQuery, prevState))
      }
      )
    }),
    async<SearchResult>(nothing, { key: 'searchResultLoader' })(props.searchResults)
      .map(resultUpdater => s0 => {
        const searchResults = resultUpdater(s0.searchResults)
        if (searchResults.kind == 'loaded') scrollResultsToTop()
        return ({ ...s0, searchResults })
      })
  ]).map(a => a(props))
}

export const newLoadingQuery = (searchQuery: string, prevState: SearchPageState) => ({
  ...prevState,
  searchQuery,
  currentPage: 1,
  searchResults: loadingAsyncState(
    fetchSearchResults(searchQuery, 1, prevState.pageSize),
    previousResult(prevState)
  )
})

const previousResult = (s0: SearchPageState) => s0.searchResults.kind == 'loaded' || s0.searchResults.kind == 'loading'
  ? s0.searchResults.value
  : emptySearchResult

const scrollResultsToTop = () => document
  .getElementsByClassName("search-results")[0]
  .scrollIntoView({ behavior: "smooth" })